import { type FC } from 'react'

import IconVerified from '@/assets/svgs/verified.svg'
import { Box, Icon, type BoxProps, type IconProps } from '@/components'
import { COLOR_BLACK, COLOR_BRAND_YELLOW_400 } from '@/lib'

export interface VerifiedBadgeProps extends Omit<BoxProps, 'children'> {
  size?: IconProps['size']
}

export const VerifiedBadge: FC<VerifiedBadgeProps> = ({ size = 'xl', ...props }) => (
  <Box
    accessibilityElementsHidden
    aria-hidden
    importantForAccessibility='no'
    {...props}
  >
    <Icon
      aria-hidden
      as={IconVerified}
      fill={COLOR_BRAND_YELLOW_400}
      size={size}
      stroke={COLOR_BLACK}
    />
  </Box>
)
